import React from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';

import { NewsItemProps } from 'pages/News/SharedComponents';

import { LatestNewsItem } from './LatestNewsItem';
import { connector } from './connector';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

interface LatestNewsBlockProps {
  list: NewsItemProps[];
}

const _LatestNewsBlock: React.FC<LatestNewsBlockProps> = ({ list }) => {
  return (
    <div className={cx('news-list')}>
      {list.map((item) => (
        <LatestNewsItem item={item} key={item.id} />
      ))}
    </div>
  );
};

export const LatestNewsBlock = compose(
  connector,
  withAutoMetric.Item(() => ({
    name: 'LatestNewsBlock',
    block_title: 'последние новости',
  })),
)(_LatestNewsBlock);
